<template>
    <div v-if="todisplay"
         class="c-DebugHsmLog DebugFullSpaceControl HsmRenderer d-flex flex-column overflow-auto ma-1"
         :class="[`c-name-${name || 'unnamed'}`]"
         :style="sizeStyle">
        <div v-if="umls.length > 0" class="headerMenus noselect">
            <ul class="nav nav-pills">
                <li v-for="(uml, index) in umls"
                    :key="index"
                    :class="{ active: selectedItemId == index }"
                    @click="onSelect(index)">
                    <a href="#"> HSM Log {{ uml.name || '#' + index }} </a>
                </li>
            </ul>
        </div>
        <div style="gap:10px; display:flex;">
            <QBtn style="background-color: #f5f5f5;"  @click="zoom(-10)">Zoom out</QBtn>
            <QBtn style="background-color: #f5f5f5;" @click="zoom(10)">Zoom In</QBtn>
            <QBtn style="background-color: #f5f5f5;" @click="restore()">Restore</QBtn>
        </div>
        <div class="mainContent d-flex flex-column overflow-auto">
            <div>
                <div class="topsvg heightFixed"
                     style="height: 40px; overflow: hidden; position: sticky; align-self: flex-start;top: 0;z-index:99;background-color: white;">
                </div>
                <div class="bottomsvg" style="top: -40px;position: relative;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { QBtn } from 'quasar';
    import BaseComponent from './BaseComponentMixin.jsx';
    import api from '@/Services/api';
    import utils from '@/Shared/utils.jsx';
    import hsmDiagram from '@/Services/hsmDiagram';

    export default {
        name: 'DebugHsmLog',
        mixins: [BaseComponent],
        components: {
            QBtn,
        },
        data() {
            return {
                data: null,
                umlEval: null,
                model: '',
                uml: null,
                selectedItemId: 0,
            };
        },
        computed: {
            umls() {
                return utils.evaluateObject(this.umlEval, this);
            },
        },
        methods: {
            async preRenderComplete() {
                this.umlEval = utils.compileObject(this, this.controlData.Umls);

                this.selectedItemId = this.umls.length - 1;
                this.refreshDiagram();
                this.finishRenderHandler(this);
            },
            refreshDiagram() {
                this.uml = this.umls[this.selectedItemId];
                if (!this.uml) return;

                // The live HSM debug tab already holds the PlantUML text, so it needs
                // no server call at all. Only the log-driven diagrams fetch, and they
                // now fetch text rather than a rendered image.
                if (!this.uml.url) {
                    this.drawDiagram(this.uml.data);
                    return;
                }

                api.apiRequest({
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: {
                        Context: "",
                        IdList: this.uml.idList,
                        IdType: this.uml.idType,
                        TimeZone: this.uml.timeZone,
                        ShowDebug: this.uml.showDebug,
                        ShowInfo: this.uml.showInfo,
                        data: null
                    },
                    url: this.uml.url,
                    doNotUseWebsocket: true,
                    doNotStandardizeUrl: true
                }).then(response => {
                    this.drawDiagram(response.data);
                });
            },
            drawDiagram(umlText) {
                var topsvg = this.$el.getElementsByClassName('topsvg')[0];
                var bottomsvg = this.$el.getElementsByClassName('bottomsvg')[0];

                // Rendered twice on purpose: topsvg is clipped to a 40px band so the
                // participant row stays pinned while bottomsvg scrolls under it.
                var opts = { onLinkClick: (href, label) => this.onDiagramLink(href, label) };
                hsmDiagram.render(umlText, bottomsvg, opts);
                hsmDiagram.render(umlText, topsvg, opts);

                this.restore();
                this.zoom(-30); // zoom out by 30% initially
            },
            onDiagramLink(href) {
                // Replaces the javascript: URL the server used to embed in the SVG.
                // The hidden SelectedValue input still owns the detail modal, so keep
                // driving it the same way, just without smuggling code through a href.
                var detailKey = href.replace(/^detail:/, '');

                var host = document.getElementsByClassName('cc-selectedAction')[0];
                if (!host) return;
                var inputBox = host.getElementsByTagName('input')[0];
                if (!inputBox) return;

                inputBox.value = detailKey;
                inputBox.dispatchEvent(new Event('change'));

                // Vue 3 puts no __vue__ on elements (the Vue 2 portal drives the input that way), so find
                // the hidden input's control by its root element and run its own change path.
                var control = Object.values(utils.global_control_lookup)
                    .find(c => c && c.$el && (c.$el === host || host.contains(c.$el)) && typeof c.onInput === 'function' && typeof c.onChange === 'function');
                if (control) {
                    control.onInput(detailKey);
                    control.onChange();
                }
            },
            onSelect(index) {
                this.selectedItemId = index;
                this.refreshDiagram();
            },
            restore() {
                var topsvgdiv = this.$el.getElementsByClassName('topsvg')[0];
                var topsvg = this.$el.getElementsByClassName('topsvg')[0].children[0];
                var bottomsvgdiv = this.$el.getElementsByClassName('bottomsvg')[0];
                var bottomsvg = this.$el.getElementsByClassName('bottomsvg')[0].children[0];

                this.restoreHeightWidth(topsvgdiv);
                this.restoreHeightWidth(topsvg);
                this.restoreTop(bottomsvgdiv);
                this.restoreHeightWidth(bottomsvg);
            },
            restoreHeightWidth(element) {
                if (element?.originalHeightWidth) {
                    element.style.height = element.originalHeightWidth.height;
                    element.style.width = element.originalHeightWidth.width;
                    element.zoomFactor = 100;
                }
            },
            restoreTop(element) {
                if (element?.originalTop) {
                    element.style.top = element.originalTop.top;
                    element.zoomFactor = 100;
                }
            },
            zoom(amt) {
                var topsvgdiv = this.$el.getElementsByClassName('topsvg')[0];
                var topsvg = this.$el.getElementsByClassName('topsvg')[0].children[0];
                var bottomsvgdiv = this.$el.getElementsByClassName('bottomsvg')[0];
                var bottomsvg = this.$el.getElementsByClassName('bottomsvg')[0].children[0];

                this.scaleHeightWidth(topsvgdiv, amt);
                this.scaleHeightWidth(topsvg, amt);
                this.scaleTop(bottomsvgdiv, amt);
                this.scaleHeightWidth(bottomsvg, amt);
            },
            scaleHeightWidth(element, amt) {
                if (!element.originalHeightWidth) {
                    element.originalHeightWidth = {
                        height: element.style.height,
                        width: element.style.width
                    };

                    element.zoomFactor = 100;
                }

                element.zoomFactor += amt;

                var height = Number(element.originalHeightWidth.height.replace("px", ""));
                height = height * (element.zoomFactor / 100.0);
                element.style.height = height + "px";

                if (element.originalHeightWidth.width) {
                    var width = Number(element.originalHeightWidth.width.replace("px", ""));
                    width = width * (element.zoomFactor / 100.0);
                    element.style.width = width + "px";
                }
            },
            scaleTop(element, amt) {
                if (!element?.originalTop) {
                    element.originalTop = {
                        top: element.style.top,
                    };

                    element.zoomFactor = 100;
                }

                element.zoomFactor += amt;

                var top = Number(element.originalTop.top.replace("px", ""));
                top = top * (element.zoomFactor / 100.0);
                element.style.top = top + "px";
            },
        },
    };
</script>

<style scoped>
</style>
